var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineFilters32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1673 6.66667C19.1673 5.19391 17.9734 4 16.5007 4C15.0279 4 13.834 5.19391 13.834 6.66667M19.1673 6.66667C19.1673 8.13943 17.9734 9.33333 16.5007 9.33333C15.0279 9.33333 13.834 8.13943 13.834 6.66667M19.1673 6.66667H27.1673M13.834 6.66667L5.83398 6.66667M21.834 16C21.834 17.4728 23.0279 18.6667 24.5006 18.6667C25.9734 18.6667 27.1673 17.4728 27.1673 16C27.1673 14.5272 25.9734 13.3333 24.5006 13.3333C23.0279 13.3333 21.834 14.5272 21.834 16ZM21.834 16H5.83398M11.1673 25.3333C11.1673 23.8606 9.97341 22.6667 8.50065 22.6667C7.02789 22.6667 5.83399 23.8606 5.83399 25.3333C5.83399 26.8061 7.02789 28 8.50065 28C9.97341 28 11.1673 26.8061 11.1673 25.3333ZM11.1673 25.3333H27.1673",
    stroke: "#1778E1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineFilters32);
export default __webpack_public_path__ + "static/media/outline-filters-32.09555b6a.svg";
export { ForwardRef as ReactComponent };